export default __webpack_public_path__ + "static/media/5.e4aab7bb.jpg";